'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------

/**
  * InitializeMeta - Initializes the website with generic meta tags and also configures react-helmet
  *
  * @example
    <InitializeMeta />
  *
  * @version 0.0.1
  * @todo none
  */


var InitializeMeta = function InitializeMeta(props) {
  var data = props.data;
  return _react2.default.createElement(_reactHelmet.Helmet, {
    htmlAttributes: {
      lang: 'en'
    },
    titleTemplate: data.titleTemplate,
    meta: [// ---- Recommended Minimum
    {
      name: 'charset',
      content: 'utf-8'
    }, {
      'http-equiv': 'x-ua-compatible',
      content: 'ie=edge'
    }, {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1'
    }, // ---- Mobile viewport optimization
    {
      name: 'HandheldFriendly',
      content: 'True'
    }, {
      name: 'MobileOptimized',
      content: '320'
    }, // ---- Makes sure the website shows up in all countries and languages
    {
      name: 'coverage',
      content: 'Worldwide'
    }, {
      name: 'distribution',
      content: 'Global'
    }, // ---- Gives a general age rating based on sites content
    {
      name: 'rating',
      content: 'General'
    }, // ---- Enable automatic detection and formatting
    {
      name: 'format-detection',
      content: 'telephone=yes'
    }, {
      name: 'format-detection',
      content: 'date=yes'
    }, {
      name: 'format-detection',
      content: 'address=yes'
    }, {
      name: 'format-detection',
      content: 'email=yes'
    }, // ---- Sends referrer information to secure HTTPS sites, but not insecure HTTP sites
    {
      name: 'referrer',
      content: 'no-referrer-when-downgrade'
    }]
  });
}; // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------


InitializeMeta.propTypes = process.env.NODE_ENV !== "production" ? {
  data: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types

} : {};
InitializeMeta.defaultProps = {
  data: {
    titleTemplate: '%s'
  } // ----------------------------------------------------------------------------
  // --------------------------------------------------------------------- Export
  // ----------------------------------------------------------------------------

};
exports.default = InitializeMeta;
module.exports = exports['default'];